export default {"src":"/_next/static/media/modern-kitchen.d77a751c.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};